(() => {
  const source = document.querySelector('[data-cart-surprise-image]');
  if (!source) return;
  const preload = new Image(); preload.src = source.dataset.cartSurpriseImage;
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches || document.body.dataset.motion === 'false';
  let overlay, timeout;
  function clear() { overlay?.remove(); clearTimeout(timeout); }
  function surprise(parent) {
    if (reduced() || document.hidden) return false;
    if (!preload.complete || !preload.naturalWidth) return false;
    clear();
    overlay = document.createElement('div');
    overlay.className = 'cart-surprise'; overlay.setAttribute('aria-hidden','true');
    const image = document.createElement('img'); image.src = preload.src; image.alt = ''; image.width = 1024; image.height = 1024;
    overlay.append(image); parent.append(overlay);
    window.dispatchEvent(new Event('vice:cart-surprise'));
    timeout = setTimeout(clear, 2400);
    return true;
  }
  document.querySelectorAll('a[href]').forEach(link => {
    const cartLink = document.querySelector('.cart-link');
    if (!cartLink || link.href !== cartLink.href) return;
    link.addEventListener('click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
      if (!surprise(link.closest('dialog[open]') || document.body)) return;
      event.preventDefault();
      setTimeout(() => location.assign(link.href), 2400);
    });
  });
  const dialog = document.querySelector('[data-cart-dialog]');
  if (dialog) new MutationObserver(() => { if (dialog.open) surprise(dialog); else clear(); }).observe(dialog,{attributes:true,attributeFilter:['open']});
  window.addEventListener('afterdark:motion', () => { if (reduced()) clear(); });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') clear(); });
})();
